import bem from 'utils/bem';

export const block = bem('projects-page-create-tab');
